"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3723],{

/***/ 36712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A8": function() { return /* binding */ resendVerificationEmail; },
/* harmony export */   "AF": function() { return /* binding */ deleteUserFromEvent; },
/* harmony export */   "Bb": function() { return /* binding */ getEventChatRoom; },
/* harmony export */   "Bt": function() { return /* binding */ deleteEvent; },
/* harmony export */   "DL": function() { return /* binding */ postChallengeItemUser; },
/* harmony export */   "Dd": function() { return /* binding */ approveUsersChallenge; },
/* harmony export */   "Do": function() { return /* binding */ postSuggestion; },
/* harmony export */   "ER": function() { return /* binding */ getChallengeUsersForInvite; },
/* harmony export */   "F": function() { return /* binding */ postGroupInviteUser; },
/* harmony export */   "F8": function() { return /* binding */ patchChallengeItemUser; },
/* harmony export */   "FH": function() { return /* binding */ getPrivacyPolicy; },
/* harmony export */   "Fr": function() { return /* binding */ searchChallenges; },
/* harmony export */   "GR": function() { return /* binding */ patchEvent; },
/* harmony export */   "GS": function() { return /* binding */ deleteUsersGroup; },
/* harmony export */   "Go": function() { return /* binding */ markAllNotificationsAsRead; },
/* harmony export */   "HO": function() { return /* binding */ deleteChallengeItemUser; },
/* harmony export */   "H_": function() { return /* binding */ deleteUsersChallenge; },
/* harmony export */   "K9": function() { return /* binding */ getNotificationsPreferences; },
/* harmony export */   "K_": function() { return /* binding */ postRatings; },
/* harmony export */   "Kd": function() { return /* binding */ getPoll; },
/* harmony export */   "Kn": function() { return /* binding */ getAddress; },
/* harmony export */   "LJ": function() { return /* binding */ getActivityGroups; },
/* harmony export */   "Oi": function() { return /* binding */ getTermsOfService; },
/* harmony export */   "Ov": function() { return /* binding */ joinUserToChallenge; },
/* harmony export */   "PR": function() { return /* binding */ getUser; },
/* harmony export */   "QH": function() { return /* binding */ getUserEvents; },
/* harmony export */   "RH": function() { return /* binding */ toggleChatRoomMute; },
/* harmony export */   "S3": function() { return /* binding */ handleError; },
/* harmony export */   "SN": function() { return /* binding */ declineUsersEvent; },
/* harmony export */   "T2": function() { return /* binding */ getChallengeItem; },
/* harmony export */   "T5": function() { return /* binding */ postChallengeInviteUser; },
/* harmony export */   "TH": function() { return /* binding */ getNotifications; },
/* harmony export */   "U9": function() { return /* binding */ postEvent; },
/* harmony export */   "UG": function() { return /* binding */ confirmEmail; },
/* harmony export */   "Ui": function() { return /* binding */ sendPollAnswers; },
/* harmony export */   "Vb": function() { return /* binding */ getLanguages; },
/* harmony export */   "Wi": function() { return /* binding */ getAdminGroups; },
/* harmony export */   "YS": function() { return /* binding */ getGroupChatRoom; },
/* harmony export */   "_E": function() { return /* binding */ patchUsersGroup; },
/* harmony export */   "_b": function() { return /* binding */ getChatRoomMessages; },
/* harmony export */   "_z": function() { return /* binding */ getUserChallenges; },
/* harmony export */   "ab": function() { return /* binding */ deleteDeviceToken; },
/* harmony export */   "b3": function() { return /* binding */ getUsersForInvite; },
/* harmony export */   "bo": function() { return /* binding */ getEmailPreferences; },
/* harmony export */   "bq": function() { return /* binding */ getGroupMembers; },
/* harmony export */   "cj": function() { return /* binding */ joinUserToEvent; },
/* harmony export */   "dK": function() { return /* binding */ postEventInviteUser; },
/* harmony export */   "dV": function() { return /* binding */ getGroupPolls; },
/* harmony export */   "di": function() { return /* binding */ getChatRooms; },
/* harmony export */   "ex": function() { return /* binding */ getGroup; },
/* harmony export */   "f8": function() { return /* binding */ postGroup; },
/* harmony export */   "fU": function() { return /* binding */ getChallengeDetail; },
/* harmony export */   "g": function() { return /* binding */ postUserActivities; },
/* harmony export */   "gT": function() { return /* binding */ searchEvents; },
/* harmony export */   "gg": function() { return /* binding */ uploadAvatar; },
/* harmony export */   "he": function() { return /* binding */ deleteProfile; },
/* harmony export */   "iE": function() { return /* binding */ deleteGroup; },
/* harmony export */   "iL": function() { return /* binding */ hasUnreadGroupsEvents; },
/* harmony export */   "ir": function() { return /* binding */ patchGroup; },
/* harmony export */   "jA": function() { return /* binding */ getGroups; },
/* harmony export */   "l9": function() { return /* binding */ getSubgroups; },
/* harmony export */   "lg": function() { return /* binding */ getHandleNotification; },
/* harmony export */   "ln": function() { return /* binding */ getShareableUsersInGroups; },
/* harmony export */   "mc": function() { return /* binding */ getGroupUsersForInvite; },
/* harmony export */   "nU": function() { return /* binding */ patchChallenge; },
/* harmony export */   "no": function() { return /* binding */ deleteNotification; },
/* harmony export */   "nw": function() { return /* binding */ deleteChallenge; },
/* harmony export */   "o3": function() { return /* binding */ postPoll; },
/* harmony export */   "pQ": function() { return /* binding */ getEventUsersForInvite; },
/* harmony export */   "pi": function() { return /* binding */ usersGroupDisplayedNow; },
/* harmony export */   "qF": function() { return /* binding */ getActivities; },
/* harmony export */   "qS": function() { return /* binding */ patchUser; },
/* harmony export */   "qy": function() { return /* binding */ getEventDetail; },
/* harmony export */   "r5": function() { return /* binding */ hideChatRoom; },
/* harmony export */   "rQ": function() { return /* binding */ deleteUserFromChallenge; },
/* harmony export */   "rj": function() { return /* binding */ getUnreadNotificationsCount; },
/* harmony export */   "sS": function() { return /* binding */ getGeneratePin; },
/* harmony export */   "sh": function() { return /* binding */ getUsersRatings; },
/* harmony export */   "th": function() { return /* binding */ hasUnreadMessages; },
/* harmony export */   "u5": function() { return /* binding */ getAvailableLocales; },
/* harmony export */   "ud": function() { return /* binding */ approveUsersEvent; },
/* harmony export */   "v8": function() { return /* binding */ postChallenge; },
/* harmony export */   "vw": function() { return /* binding */ getEvents; },
/* harmony export */   "wo": function() { return /* binding */ postDeviceToken; },
/* harmony export */   "wz": function() { return /* binding */ getCurrentUserActivities; },
/* harmony export */   "xd": function() { return /* binding */ approveUsersGroup; },
/* harmony export */   "yB": function() { return /* binding */ getChallenges; },
/* harmony export */   "yH": function() { return /* binding */ getChatRoom; }
/* harmony export */ });
/* unused harmony exports removeEmptyStrings, bearerHeader, singInPost, getEventUsersWithHeaders, postMessage, verifySessionToken */
/* harmony import */ var _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2082);
/* harmony import */ var _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80443);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1676);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18495);
/* harmony import */ var _session__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49003);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var removeEmptyStrings = function(obj) {
    var newObj = {};
    for(var key in obj){
        if (obj[key] === "") {
            newObj[key] = null;
        } else {
            newObj[key] = obj[key];
        }
    }
    return newObj;
};
var bearerHeader = function(session) {
    var ref;
    return "Bearer ".concat(session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.accessToken);
};
var api = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
    baseURL: "https://api.unalanu.com" || 0,
    headers: {
        "Content-Type": "application/json"
    }
});
api.interceptors.request.use(function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(request) {
        var ref, session;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.getSession)();
                case 3:
                    session = _ctx.sent;
                    if (session === null || session === void 0 ? void 0 : session.user) {
                        request.headers.Authorization = bearerHeader(session);
                    }
                    request.headers["Accept-Language"] = (session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.locale) || "en";
                    return _ctx.abrupt("return", request);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(request) {
        return _ref.apply(this, arguments);
    };
}());
api.interceptors.response.use(function(response) {
    return response;
}, function(err) {
    var ref15, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var not_signed_message = "Not signed in";
    if (((ref15 = err.response) === null || ref15 === void 0 ? void 0 : ref15.status) === 401 && ((ref1 = err.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.errors) === null || ref3 === void 0 ? void 0 : ref3.at(0)) === not_signed_message) {
        if (err.response.config.url.includes("verify_token")) {
            (0,_session__WEBPACK_IMPORTED_MODULE_3__/* .signOutUser */ .M)();
        } else {
            verifySessionToken().catch(function(error) {
                var ref, ref12, ref13, ref14;
                if (((ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 401 && ((ref12 = err.response) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.errors) === null || ref14 === void 0 ? void 0 : ref14.at(0)) === not_signed_message) {
                    (0,_session__WEBPACK_IMPORTED_MODULE_3__/* .signOutUser */ .M)();
                }
            });
        }
    }
    (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .setContext */ .v)("error_data", {
        base_url: (ref4 = err.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.config) === null || ref5 === void 0 ? void 0 : ref5.baseURL,
        pathname: (ref6 = err.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.config) === null || ref7 === void 0 ? void 0 : ref7.url,
        params: JSON.stringify((ref8 = err.response) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.config) === null || ref9 === void 0 ? void 0 : ref9.params),
        incomming_errors: (ref10 = err.response) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : ref11.errors
    });
    (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(err);
    return Promise.reject(err);
});
var handleError = function(error, router) {
    var ref;
    var status = (ref = error.response) === null || ref === void 0 ? void 0 : ref.status;
    if (!status) return;
    if (status == 403) router.replace("/403");
    if (status == 404) router.replace("/404");
    if (status == 500) router.replace("/500");
};
var getGeneratePin = function(params) {
    return api.post("/api/v1/sign_in/generate_pin", params);
};
var singInPost = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(phone, pin) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/sign_in", {
                        params: {
                            phone: phone,
                            pin: pin
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function singInPost(phone, pin) {
        return _ref.apply(this, arguments);
    };
}();
var patchUser = function(user) {
    return api.patch("/api/v1/profile", {
        user: removeEmptyStrings(user)
    });
};
var uploadAvatar = function(file) {
    var formData = new FormData();
    formData.append("avatar", file);
    return api.post("/api/v1/profile/upload_avatar", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};
var getUser = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/profile/".concat(id));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUser(id) {
        return _ref.apply(this, arguments);
    };
}();
var getActivityGroups = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var withActivities, data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    withActivities = param.withActivities;
                    _ctx.next = 3;
                    return api.get("/api/v1/activity_groups", {
                        params: {
                            with_activities: withActivities
                        }
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getActivityGroups(_) {
        return _ref.apply(this, arguments);
    };
}();
var getActivities = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(activityGroupId) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (activityGroupId) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 2:
                    _ctx.next = 4;
                    return api.get("/api/v1/activity_groups/".concat(activityGroupId, "/activities"));
                case 4:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getActivities(activityGroupId) {
        return _ref.apply(this, arguments);
    };
}();
var getCurrentUserActivities = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/users_activities");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCurrentUserActivities() {
        return _ref.apply(this, arguments);
    };
}();
var postUserActivities = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(users_activities) {
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", api.post("/api/v1/users_activities", {
                        users_activities: users_activities
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postUserActivities(users_activities) {
        return _ref.apply(this, arguments);
    };
}();
var getGroups = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/user/groups", {
                        params: {
                            page: params.pageParam,
                            q: params.q,
                            per_page: params.perPage
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGroups(params) {
        return _ref.apply(this, arguments);
    };
}();
var getAdminGroups = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/user/admin_groups", {
                        params: {
                            page: params.pageParam,
                            q: params.q,
                            per_page: params.perPage
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAdminGroups(params) {
        return _ref.apply(this, arguments);
    };
}();
var postGroup = function(formData) {
    return api.post("/api/v1/groups", formData);
};
var patchGroup = function(formData) {
    return api.patch("/api/v1/groups/".concat(formData.token), formData);
};
var getGroup = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/groups/".concat(token));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGroup(token) {
        return _ref.apply(this, arguments);
    };
}();
var patchUsersGroup = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id, params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.patch("/api/v1/users_groups/".concat(id), params);
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function patchUsersGroup(id, params) {
        return _ref.apply(this, arguments);
    };
}();
var getSubgroups = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var params, data, _args = arguments;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
                    _ctx.next = 3;
                    return api.get("/api/v1/groups/".concat(token, "/subgroups"), {
                        params: params
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSubgroups(token) {
        return _ref.apply(this, arguments);
    };
}();
var getLanguages = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/languages");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLanguages() {
        return _ref.apply(this, arguments);
    };
}();
var getNotifications = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/notifications", {
                        params: {
                            page: params.pageParam,
                            per_page: params.per_page,
                            q: params.q
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getNotifications(params) {
        return _ref.apply(this, arguments);
    };
}();
var deleteNotification = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.delete("/api/v1/notifications/".concat(id));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteNotification(id) {
        return _ref.apply(this, arguments);
    };
}();
var getGroupMembers = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/groups/".concat(params.token, "/members"), {
                        params: {
                            page: params.pageParam,
                            per_page: params.per_page,
                            q: params.q
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGroupMembers(params) {
        return _ref.apply(this, arguments);
    };
}();
var getGroupPolls = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/groups/".concat(params.token, "/polls"), {
                        params: {
                            page: params.pageParam,
                            per_page: params.per_page
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGroupPolls(params) {
        return _ref.apply(this, arguments);
    };
}();
var postPoll = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", api.post("/api/v1/polls", data));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postPoll(data) {
        return _ref.apply(this, arguments);
    };
}();
var postSuggestion = function(formData) {
    return api.post("/api/v1/suggestions", formData);
};
var postEvent = function(data) {
    return api.post("/api/v1/events", data);
};
var patchEvent = function(slug, data) {
    return api.patch("/api/v1/events/".concat(slug), data);
};
var getEventDetail = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var headers, data, _args = arguments;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    headers = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
                    _ctx.next = 3;
                    return api.get("/api/v1/events/".concat(slug), {
                        headers: headers
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEventDetail(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getEventUsersWithHeaders = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug, headers) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/events/".concat(slug), {
                        headers: headers
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEventUsersWithHeaders(slug, headers) {
        return _ref.apply(this, arguments);
    };
}();
var getEvents = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/events", {
                        params: {
                            q: params.q,
                            page: params.pageParam
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEvents(params) {
        return _ref.apply(this, arguments);
    };
}();
var getUserEvents = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/user/events", {
                        params: {
                            q: params.q,
                            page: params.pageParam,
                            per_page: params.per_page
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUserEvents(params) {
        return _ref.apply(this, arguments);
    };
}();
var getGroupUsersForInvite = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/groups/".concat(params.token, "/users_for_invite"), {
                        params: {
                            page: params.pageParam,
                            q: params.q,
                            per_page: params.per_page
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGroupUsersForInvite(params) {
        return _ref.apply(this, arguments);
    };
}();
var postGroupInviteUser = function(token, user_id) {
    return api.post("/api/v1/groups/".concat(token, "/invite_user"), {
        user_id: user_id
    });
};
var joinUserToEvent = function(slug, user_id) {
    return api.post("/api/v1/events/".concat(slug, "/join"), {
        user_id: user_id
    });
};
var deleteUserFromEvent = function(users_event_id) {
    return api.delete("/api/v1/users_events/".concat(users_event_id));
};
var deleteGroup = function(token) {
    return api.delete("/api/v1/groups/".concat(token));
};
var searchEvents = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/search", {
                        params: {
                            page: params.pageParam,
                            q: params.q,
                            per_page: 10
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function searchEvents(params) {
        return _ref.apply(this, arguments);
    };
}();
var approveUsersGroup = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/users_groups/".concat(id, "/approve"));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function approveUsersGroup(id) {
        return _ref.apply(this, arguments);
    };
}();
var deleteUsersGroup = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", api.delete("/api/v1/users_groups/".concat(id)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteUsersGroup(id) {
        return _ref.apply(this, arguments);
    };
}();
var approveUsersEvent = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/users_events/".concat(id, "/approve"));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function approveUsersEvent(id) {
        return _ref.apply(this, arguments);
    };
}();
var declineUsersEvent = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/users_events/".concat(id, "/decline"));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function declineUsersEvent(id) {
        return _ref.apply(this, arguments);
    };
}();
var getPoll = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/polls/".concat(id));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPoll(id) {
        return _ref.apply(this, arguments);
    };
}();
var sendPollAnswers = function(id, option_ids) {
    return api.post("/api/v1/polls/".concat(id, "/polls_answers"), {
        vote_poll_options_ids: option_ids
    });
};
var getChatRooms = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/chat_rooms", {
                        params: {
                            page: params.pageParam,
                            per_page: params.per_page,
                            q: params.q
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getChatRooms(params) {
        return _ref.apply(this, arguments);
    };
}();
var getChatRoom = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/chat_rooms/".concat(id));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getChatRoom(id) {
        return _ref.apply(this, arguments);
    };
}();
var getGroupChatRoom = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/groups/".concat(token, "/chat_room"));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGroupChatRoom(token) {
        return _ref.apply(this, arguments);
    };
}();
var getEventChatRoom = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/events/".concat(slug, "/chat_room"));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEventChatRoom(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getChatRoomMessages = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/chat_rooms/".concat(params.id, "/messages"), {
                        params: {
                            q: params.q,
                            page: params.pageParam,
                            per_page: params.per_page
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getChatRoomMessages(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessage = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chat_room_id, body) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.post("/api/v1/chat_rooms/".concat(chat_room_id, "/message"), {
                        message: {
                            body: body
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postMessage(chat_room_id, body) {
        return _ref.apply(this, arguments);
    };
}();
var postRatings = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug, ratings) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.post("/api/v1/events/".concat(slug, "/ratings"), {
                        ratings: ratings
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postRatings(slug, ratings) {
        return _ref.apply(this, arguments);
    };
}();
var getUsersRatings = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/events/".concat(slug, "/ratings"));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUsersRatings(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getEventUsersForInvite = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/events/".concat(params.slug, "/users_for_invite"), {
                        params: {
                            page: params.pageParam,
                            q: params.q,
                            per_page: params.per_page
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEventUsersForInvite(params) {
        return _ref.apply(this, arguments);
    };
}();
var postEventInviteUser = function(slug, user_id) {
    return api.post("/api/v1/events/".concat(slug, "/invite_user"), {
        user_id: user_id
    });
};
var getUsersForInvite = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/users_for_invite", {
                        params: {
                            page: params.pageParam,
                            q: params.q,
                            per_page: params.per_page
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUsersForInvite(params) {
        return _ref.apply(this, arguments);
    };
}();
var deleteEvent = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.delete("/api/v1/events/".concat(slug));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteEvent(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getUnreadNotificationsCount = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/notifications/unread");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUnreadNotificationsCount() {
        return _ref.apply(this, arguments);
    };
}();
var markAllNotificationsAsRead = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/notifications/mark_all_as_read");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function markAllNotificationsAsRead() {
        return _ref.apply(this, arguments);
    };
}();
var getHandleNotification = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id, handler) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/notifications/".concat(id, "/handle"), {
                        params: {
                            handler: handler
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getHandleNotification(id, handler) {
        return _ref.apply(this, arguments);
    };
}();
var getAddress = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lat, lng) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/geo_locations/address", {
                        params: {
                            lat: lat,
                            lng: lng
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAddress(lat, lng) {
        return _ref.apply(this, arguments);
    };
}();
var deleteProfile = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.delete("/api/v1/profile");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteProfile() {
        return _ref.apply(this, arguments);
    };
}();
var hasUnreadMessages = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/profile/has_unread_messages");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function hasUnreadMessages() {
        return _ref.apply(this, arguments);
    };
}();
var hasUnreadGroupsEvents = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/profile/has_unread_groups_events");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function hasUnreadGroupsEvents() {
        return _ref.apply(this, arguments);
    };
}();
var usersGroupDisplayedNow = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/users_groups/".concat(id, "/displayed_now"));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function usersGroupDisplayedNow(id) {
        return _ref.apply(this, arguments);
    };
}();
var hideChatRoom = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.delete("/api/v1/chat_rooms/".concat(id, "/hide"));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function hideChatRoom(id) {
        return _ref.apply(this, arguments);
    };
}();
var verifySessionToken = function() {
    return api.get("/api/v1/sessions/verify_token");
};
var postDeviceToken = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(device) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.post("/api/v1/devices", {
                        device: device
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postDeviceToken(device) {
        return _ref.apply(this, arguments);
    };
}();
var deleteDeviceToken = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.delete("/api/v1/devices/".concat(token));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteDeviceToken(token) {
        return _ref.apply(this, arguments);
    };
}();
var getPrivacyPolicy = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/privacy_policy");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPrivacyPolicy() {
        return _ref.apply(this, arguments);
    };
}();
var getTermsOfService = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/terms_of_service");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTermsOfService() {
        return _ref.apply(this, arguments);
    };
}();
var confirmEmail = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/user/confirm_email/".concat(token));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function confirmEmail(token) {
        return _ref.apply(this, arguments);
    };
}();
var resendVerificationEmail = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/profile/resend_verification_email");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function resendVerificationEmail() {
        return _ref.apply(this, arguments);
    };
}();
var getEmailPreferences = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/emails/preferences");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEmailPreferences() {
        return _ref.apply(this, arguments);
    };
}();
var getNotificationsPreferences = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/notifications/preferences");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getNotificationsPreferences() {
        return _ref.apply(this, arguments);
    };
}();
var getShareableUsersInGroups = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/groups/shareable_users", {
                        params: params
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getShareableUsersInGroups(params) {
        return _ref.apply(this, arguments);
    };
}();
var postChallenge = function(data) {
    return api.post("/api/v1/challenges", {
        challenge: data
    });
};
var patchChallenge = function(slug, data) {
    return api.patch("/api/v1/challenges/".concat(slug), {
        challenge: data
    });
};
var getChallengeDetail = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var headers, data, _args = arguments;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    headers = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
                    _ctx.next = 3;
                    return api.get("/api/v1/challenges/".concat(slug), {
                        headers: headers
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getChallengeDetail(slug) {
        return _ref.apply(this, arguments);
    };
}();
var deleteChallenge = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.delete("/api/v1/challenges/".concat(slug));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteChallenge(slug) {
        return _ref.apply(this, arguments);
    };
}();
var joinUserToChallenge = function(slug, user_id) {
    return api.post("/api/v1/challenges/".concat(slug, "/join"), {
        user_id: user_id
    });
};
var deleteUserFromChallenge = function(users_challenge_id) {
    return api.delete("/api/v1/users_challenges/".concat(users_challenge_id));
};
var getChallengeUsersForInvite = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/challenges/".concat(params.slug, "/users_for_invite"), {
                        params: {
                            page: params.pageParam,
                            q: params.q,
                            per_page: params.per_page
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getChallengeUsersForInvite(params) {
        return _ref.apply(this, arguments);
    };
}();
var postChallengeInviteUser = function(slug, user_id) {
    return api.post("/api/v1/challenges/".concat(slug, "/invite_user"), {
        user_id: user_id
    });
};
var getChallengeItem = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/challenge_items/".concat(id));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getChallengeItem(id) {
        return _ref.apply(this, arguments);
    };
}();
var postChallengeItemUser = function(challenge_item_id) {
    return api.post("/api/v1/challenge_item_users/".concat(challenge_item_id));
};
var deleteChallengeItemUser = function(challenge_item_id) {
    return api.delete("/api/v1/challenge_item_users/".concat(challenge_item_id));
};
var patchChallengeItemUser = function(challenge_item_id, params) {
    return api.patch("/api/v1/challenge_item_users/".concat(challenge_item_id), params);
};
var getChallenges = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/challenges", {
                        params: {
                            q: params.q,
                            page: params.pageParam
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getChallenges(params) {
        return _ref.apply(this, arguments);
    };
}();
var getUserChallenges = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/user/challenges", {
                        params: {
                            q: params.q,
                            page: params.pageParam,
                            per_page: params.per_page
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUserChallenges(params) {
        return _ref.apply(this, arguments);
    };
}();
var searchChallenges = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/user/challenges/search", {
                        params: {
                            page: params.pageParam,
                            q: params.q,
                            per_page: 25
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function searchChallenges(params) {
        return _ref.apply(this, arguments);
    };
}();
var approveUsersChallenge = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/v1/users_challenges/".concat(id, "/approve"));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function approveUsersChallenge(id) {
        return _ref.apply(this, arguments);
    };
}();
var deleteUsersChallenge = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.delete("/api/v1/users_challenges/".concat(id));
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteUsersChallenge(id) {
        return _ref.apply(this, arguments);
    };
}();
var getAvailableLocales = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("/api/available_locales");
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAvailableLocales() {
        return _ref.apply(this, arguments);
    };
}();
var toggleChatRoomMute = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var data;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = api.get("/api/v1/chat_rooms/".concat(id, "/toggle_mute")).data;
                    return _ctx.abrupt("return", data);
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function toggleChatRoomMute(id) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 49003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ signOutUser; },
/* harmony export */   "c": function() { return /* binding */ updateUserSession; }
/* harmony export */ });
/* harmony import */ var _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2082);
/* harmony import */ var _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1676);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36712);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var updateUserSession = function() {
    var _ref = _asyncToGenerator(_tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(credentials) {
        var result;
        return _tmp_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signIn)("credentials", _objectSpread({}, credentials, {
                        type: "update_session",
                        redirect: false
                    }));
                case 2:
                    result = _ctx.sent;
                    return _ctx.abrupt("return", result);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateUserSession(credentials) {
        return _ref.apply(this, arguments);
    };
}();
var signOutUser = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _session = ref.session, session = _session === void 0 ? null : _session, _signOutParams = ref.signOutParams, signOutParams = _signOutParams === void 0 ? {} : _signOutParams, _afterSignOut = ref.afterSignOut, afterSignOut = _afterSignOut === void 0 ? null : _afterSignOut;
    var ref1;
    if (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.deviceToken) {
        (0,_queries__WEBPACK_IMPORTED_MODULE_2__/* .deleteDeviceToken */ .ab)(session.user.deviceToken).then(function(response) {
            return handleSignOut({
                signOutParams: signOutParams,
                afterSignOut: afterSignOut
            });
        }).catch(function(error) {
            return handleSignOut({
                signOutParams: signOutParams,
                afterSignOut: afterSignOut
            });
        });
    } else {
        handleSignOut({
            signOutParams: signOutParams,
            afterSignOut: afterSignOut
        });
    }
};
var handleSignOut = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _signOutParams = ref.signOutParams, signOutParams = _signOutParams === void 0 ? {} : _signOutParams, _afterSignOut = ref.afterSignOut, afterSignOut = _afterSignOut === void 0 ? null : _afterSignOut;
    (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signOut)(signOutParams).then(function() {
        if (afterSignOut) afterSignOut();
    });
};


/***/ })

}]);